import React from 'react'
import styled from '@emotion/styled'
import Ajanlatkeres from '../containers/Ajanlatkeres'
import i00001 from '../images/festes/00001.jpg'
import i00002 from '../images/festes/00002.jpg'
import i00003 from '../images/festes/00003.jpg'
import i00004 from '../images/festes/00004.jpg'
import i00005 from '../images/festes/00005.jpg'
import i00006 from '../images/festes/00006.jpg'

const Main = styled.main`
  margin-top: 70px;
  line-height: 1.5rem;
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2.5rem;
  }
`

const SubTitle = styled.h3`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2rem;
  }
`

const Section = styled.section`
  position: relative;
  padding: 0 1rem;
  padding-bottom: 8px;
  margin: 2rem 0;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    list-style: circle;

    li {
      margin: 0.5rem 0;

      a:after {
        content: ' ›';
      }
    }
  }

  &:first-of-type {
    margin-bottom: 4rem;
  }

  &:nth-of-type(2n) {
    background: linear-gradient(transparent 80px, rgba(39, 82, 54, 0.2) 80px, rgba(39, 82, 54, 0.2) 100%);

    ${SubTitle} {
      // color: #fff;
    }

    &:before {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      top: calc(80px - 2rem);
      width: 100%;
      height: 2rem;
      background: linear-gradient(to right top, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }

    &:after {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      bottom: -2rem;
      width: 100%;
      height: 2rem;
      background: linear-gradient(to left bottom, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }
  }

  @media (min-width: 64em) {
    p,
    ul,

    ${Title}, ${SubTitle} {
      margin: 2rem auto;
      max-width: 960px;
    }

    &:nth-of-type(2n) {
      &:before {
        top: calc(80px - 4rem);
        height: 4rem;
      }

      &:after {
        bottom: -4rem;
        height: 4rem;
      }
    }
  }
`

const Images = styled.section`
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  height: 320px;
  margin: 0 -1rem;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: row;

  img {
    flex: 1;
    display: block;
    height: 100%;
  }

  img + img {
    margin-left: 5px;
  }

  @media (min-width: 64em) {
    overflow-x: auto;
    margin: 0 auto;
    max-width: 1540px;
    height: auto;
    flex-wrap: wrap;

    img {
      flex: 1;
      display: block;
      width: 30%;
      // height: auto;
      margin: 5px;
    }
  }
`

const ScrollIndicator = styled.span`
  text-align: center;
  width: 100%;
  display: block;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  color: #fff;

  @media (min-width: 64em) {
    display: none;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <Title>Külső-belső festés, mázolás. Tapétázások.</Title>
        <p>
          Egy felújítás során, le kell védeni a burkolatokat és a bútorokat egyaránt. Lehetséges, hogy javasolni fogjuk
          a korábbi festékrétegek lekaparását, a szükséges glettelés, hibajavítás sem maradhat ki, amennyiben szükséges,
          bár ez elsősorban régi építésű házaknál áll fent. A falak kiegyenesítésére is van lehetőség. Amikor a
          többszöri glettelés és csiszolásnak hála a fal felülete elnyerte a végső síkját, kezdődhet a festés, melyet
          szükség esetén több rétegben is fel lehet vinni. Cégünk mindig megpróbál a legjobb ár / érték arányban
          dolgozni, így lehetséges, hogy olyan drágább, jobb minőségű festéket javaslunk melynek kiadóssága nagyobb,
          több felületet lehet vele lefesteni. Manapság a választható festékek színe szinte végtelen, érdemes böngészni
          a színskálákat. Kezd elterjedni a szomszédos falak eltérő színűre való festése, amennyiben Ön is ez mellett
          döntene, javasoljuk, hogy a sötétebb, intenzívebb színű festéket válassza a szoba napsütéses oldalára, így a
          világosabb árnyalat a sötétebb részekben növelni fogja a tér érzetet. Legyen megfontolt a színek
          kiválasztásánál. Javasoljuk, hogy egy helyiségen belül legfeljebb 3 árnyalatot válasszon és kérje tanácsunkat,
          hiszen a falak anyaga, jellege a szoba rendeltetése a burkolatok mind-mind befolyásolják a végleges eredményt.
          A festés része a stukkók felragasztása. Ha valami különlegesre vágyik, a stukkólécekkel, igazán különlegessé
          teheti lakását. A számtalan formájú és stílusú stukkó, egyedi rozetták, díszcsíkok, mind lehetőséget
          biztosítanak arra, hogy könnyedén megtalálja az Önnek legjobban tetszőt. Vállaljuk külső homlokzatok festését,
          ablakok, ajtók mázolását. Belső lakás festését, mázolását, tapétázását.
        </p>
      </Section>
      <Section>
        <SubTitle id="kepek">Képek</SubTitle>
        <Images>
          <img src={i00001} alt="" />
          <img src={i00002} alt="" />
          <img src={i00003} alt="" />
          <img src={i00004} alt="" />
          <img src={i00005} alt="" />
          <img src={i00006} alt="" />
        </Images>
        <ScrollIndicator>◀ ● ▶</ScrollIndicator>
      </Section>
      <Ajanlatkeres />
    </Main>
  </div>
)
